import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing;
export var checkboxLabel = /*#__PURE__*/css(["flex-direction:row;display:flex;cursor:pointer;color:var(--neutral-black-base);"]);
export var checkboxLabelDisabled = /*#__PURE__*/css(["cursor:default;color:var(--neutral-black-40);"]);
export var checkboxErrorMessage = /*#__PURE__*/css(["margin-left:", ";"], pxToRem(4));
export var checkboxLabelText = /*#__PURE__*/css(["align-self:center;flex-grow:1;margin:", " 0 0 ", ";"], pxToRem(spacing.base), pxToRem(spacing.xs));